export default {
  accountCreated:
    'Fiókja létrejött. Kérjük, ellenőrizze e-mailjét, és kövesse az érvényesítési eljárást. Ha ez megtörtént, konfigurálhatja fiókját. Jó szórakozást minden beállításhoz!',
  FAILED_TO_ACTIVATE:
    'Valami történt, és nem tudtuk aktiválni a fiókját. Kérjük, ellenőrizze e-mailjét, vagy lépjen kapcsolatba ügyfélszolgálatunkkal a contact@sportya.net címen',
  SUCCESSFULLY_ACTIVATED:
    'Gratula! Sikeresen aktiváltad a fiókodat. Most már bejelentkezhet fiókja beállításának folytatásához!',
};
